import {useRouter} from 'next/router';

export const NON_CATALOG_COURSE_QUERY_PARAM = 'non-catalog-course';

export function useNonCatalogCourseParam(): string | undefined {
    const router = useRouter();
    const raw = router.query[NON_CATALOG_COURSE_QUERY_PARAM];
    if (raw === undefined) {
        return undefined;
    }
    const value = Array.isArray(raw) ? raw[0] : raw;
    return typeof value === 'string' && value.length > 0 ? value : undefined;
}
